import { ReactComponent as CloseIcon } from '../../assets/Icons/adornments/Close.svg';
import { MouseEvent } from 'react';
import { Btn } from '../Buttons/Buttons';
import PopupFooter from './PopupFooter';
import { useNavigate } from 'react-router-dom';
import SuccessIcon from '../../assets/Images/success.png';

export default function SuccessMessageModal({
    message,
    handleClose,
}: {
    message: string,
    handleClose: () => void,
}) {
    const navigate = useNavigate();

    const btns: Btn[] = [
        {
            type: 'tertiary',
            styling: 'outline',
            id: 'view-job-queue',
            label: 'View Job Queue',
            action: (e: MouseEvent<HTMLButtonElement>) => {
                navigate('/jobs');
            }
        },
        {
            type: "secondary",
            styling: "solid",
            id: 'finish',
            label: 'Finish',
            action: (e: MouseEvent<HTMLButtonElement>) => handleClose(),
        }
    ]

    return (
        <div className={`bg-white rounded-lg w-[350px] popup-menu mx-auto`}>
            <div className='flex flex-col justify-center items-stretch'>

                <div className={`w-full px-6 pt-6 flex justify-end items-center gap-3`}>
                    <button onClick={handleClose} className="text-disable hover:text-primary transition-all">
                        <div className="w-[18px] h-[18px]"><CloseIcon/></div>
                    </button>
                </div>

                <div className="w-full flex flex-col gap-8 px-6 pb-6 justify-start items-center">
                    <img src={SuccessIcon} alt='success-check-icon' className='w-[100px]'/>
                    <p className='text-[20px] font-semibold text-default'>Success</p>
                    <p className='text-default text-center'>{message}</p>
                    
                </div>

                <PopupFooter 
                    hasOutline={false}
                    buttons={btns}
                />

            </div>
        </div>
    )
}